import { Column } from '@/types/newt/column'

/**
 * カラムの著者名を取得するユーティリティ関数
 * @param column カラムオブジェクト
 * @returns 著者名
 */
export const getAuthorName = (column: Column): string => {
  if (column.authors) {
    if (typeof column.authors === 'string') {
      return column.authors
    }

    if (Array.isArray(column.authors)) {
      if (column.authors[0]) {
        if (typeof column.authors[0] === 'string') {
          return column.authors[0]
        }
        return column.authors[0]?.name || column.author || ''
      }
      return column.author || ''
    }

    return (column.authors as any)?.name || column.author || ''
  }

  return column.author || ''
}
